const Map = require('./map'),
  Errors = require('./errors');

module.exports = {Map, Errors};
